export default "__VITE_ASSET__Ctu0gNyA__"